<template>
  <v-sheet class=main--text color="rgba(249, 247, 227, 0.9)">
    <h1 class=article--title>パパママ必見！子どもの習い事将来本当に役立つのは！？</h1>
      <v-img
        :src="troubleImage">
      </v-img>
      <br>
      <p class=plain--text><b>子どもの習い事選びって、本当に悩みのタネですよね…</b></p>
      <br>
      <p class=plain--text>「なんといっても、子どもがやりたいと思ったことを！」</p>
      <p class=plain--text>と思うのは当然かもですが、その候補自体はいくつか出してあげたいもの。</p>
      <br>
      <ul class=trouble--list>
        <li>「何を選べばよいのかわからない」</li>
        <li>「将来、本当に役に立つことをやらせてあげたいけど…」</li>
      </ul>
      <br>
      <p class=plain--text>当然、こんなお悩みに行き着いちゃいますよね。</p>
      <p class=plain--text>本記事では、令和の今だからこそ選びたい「習い事」について紹介したいと思います！</p>
    <h2 class=section--text> 3人に2人の子どもが「習い事」をしている！  </h2>
    <h2 class=section--text>習い事選びのポイント！</h2>
      <p class=plain--text>では、実際の習い事を選ぶとき、どんなことを考えると良いのでしょうか。</p>
      <h3 class=subtitle--text>脳や身体能力の発達を促進するもの</h3>
        <p class=plain--text>実際に習い事を選ぶ理由でも多く挙げられるのがこれです。<br>具体的には、サッカーや水泳などのスポーツ系が人気ですね。</p>
        <p class=plain--text>幼少期から身体を動かすことに慣れておくことで、しっかりと体力を作ることができます。<br>学校やご家庭だけでは中々補えない部分ですので、習い事のなかで身に付けられるのはありがたいですよね。</p>
        <p class=plain--text>また、特に指先の器用さを意味する「巧緻性」を磨くことは、脳の発達・知能向上に繋がると言われています。<br>具体的な技能だけでなく、こうした部分を鍛えておくことで、将来の可能性を大きく伸ばすことができそうですね。</p>
      <h3 class=subtitle--text>日常的に活用できる機会に恵まれているもの</h3>
        <p class=plain--text>せっかく身につけるのでしたら、将来必ず役に立つものがいいですよね。<br>その意味では特定の業種などに依存しないものを選ぶのが良いでしょう。</p>
        <p class=plain--text>例えば、書道やそろばんなどは、広く役に立つ能力を育成できると言えます。<br>コンピュータが普及している昨今ですが、きれいな手書き・スピーディな暗算などは、今後も役に立つ場面は多そうです。</p>
    <h2 class=section--text>本当に役に立つ習い事とは？</h2>
      <p class=plain--text>以上のことを踏まえて、編集部がオススメする「本当に役に立つ習い事」をご紹介します！</p>
      <h3 class=subtitle--text></h3>
      <h3 class=subtitle--text></h3>
      <h3 class=subtitle--text>プログラミング</h3>
    <h2 class=section--text>オンラインでプログラミングを勉強しよう！</h2>
      <p class=plain--text>『Prosense』は、オンラインでお子さまにプログラミングを学習いただける通信教育サービスです。</p>
      <ul class=advantage--list>
        <li>ご家庭から好きな時間に授業を受けられる！</li>
        <li>完全リモート授業なので、送迎不要！</li>
        <li>現役エンジニアを中心とした講師陣による、マンツーマンレッスン！</li>
      </ul>
      <p class=plain--text>お子さまの、本格的なプログラミング言語、そしてコンピュータの知識の習得をお約束いたします。</p>
      <h3 class=subtitle--text>無料体験実施中！</h3>
      <a href="https://prosense.me/parent/top"><h4>詳しくはコチラから</h4></a>
  </v-sheet>
</template>

<script>
import TroubleImage from '@/assets/img/trouble.jpg'
export default {
  data () {
    return {
      troubleImage: TroubleImage
    }
  }
}
</script>

<style scoped>
.article--title {
  color: rgb(0, 0, 0);
  background-color: rgba(210, 223, 98, 0.8);
  letter-spacing: 1px;
  padding: 10px;
  border-radius: 0px;
}

.section--text {
  background-color: rgba(210, 223, 98, 0.5);
  font-size: 1.8rem;
  letter-spacing: 1px;
  padding: 5px 10px;
  margin: 30px 0px 0px 0px;
  border-radius: 0px;
}

.subtitle--text {
  background-color: rgba(210, 223, 98, 0.1);
  font-size: 1.4rem;
  padding: 5px 10px;
  margin: 30px 0 0 0;
  border-radius: 0px;
}

.plain--text {
  letter-spacing: 0px;
  font-size: 1.1rem;
  letter-spacing: 1px;
  margin: 10px 20px 10px 10px;
}

.plain--list {
  letter-spacing: 0px;
  font-size: 0.92rem;
  margin: 10px 20px 10px 10px;
}

.plain--list li {
  margin: 0px 0px 3px 0px;
}

.plain--text.end {
  text-align: right;
  padding: 10px;
}

.trouble--list {
  list-style-type: none;
  padding: 0px;
}

.trouble--list li {
  margin: 0px 0px 10px 0px;
  font-weight: bold;
  font-size: 1.5rem;
  color: brown
}

.advantage--list {
  list-style-type: none;
  padding: 10px
}

.advantage--list li {
  margin: 0px 0px 10px 0px;
  font-weight: bold;
  font-size: 1.5rem;
  color: brown;
}

</style>

